import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * The cockpit is two pages since 2026-11-02 — Pending and Resolved, under the sidebar's Blocked
 * Orders entry. The old address opens on what still needs doing, as the one page did.
 */
export const Route = createFileRoute('/_auth/_modules/credit/blocked-orders/')({
  loader: () => {
    throw redirect({ to: '/credit/blocked-orders/pending' })
  },
})
